import React, { useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';
import styles from './styles.module.scss';
import cx from 'classnames';

interface Props {
  selected: Record<string, any>;
  options: Record<string, any>[];
  onChange: (value: Record<string, any>) => void;
}

export const ActivityFilterDropDown: React.FC<Props> = ({
  selected,
  options,
  onChange,
}) => {
  const selectedOption = useMemo(() => {
    return options.find((option) => option.value === selected.value);
  }, [selected, options]);

  const handleSelect = (value: string) => {
    const option = options.find((opt) => opt.value === value);
    if (option && onChange) {
      onChange(option);
    }
  };

  return (
    <Dropdown className={styles.selectDropdown}>
      <Dropdown.Toggle as="div" className={styles.dropdownToggle}>
        <span className={styles.selectedLabel}>{selectedOption?.label}</span>
        {options.length > 1 && <i className="paperflite-dropdown" />}
      </Dropdown.Toggle>

      {options.length > 1 && (
        <Dropdown.Menu
          popperConfig={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 6],
                },
              },
            ],
          }}
          className={styles.dropdownMenu}
        >
          {options.map((option, index) => {
            const isSelected = option.value === selected.value;
            return (
              <Dropdown.Item
                key={index}
                className={cx(styles.dropdownItem, { [styles.active]: isSelected })}
                onClick={() => handleSelect(option.value)}
              >
                {isSelected ? (
                  <i className="paperflite-tick-selected" />
                ) : (
                  <i className="paperflite-radio-button-unselected" />
                )}
                <span>{option.label}</span>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};
